<button
  [attr.type]="buttonType"
  class="flow-button"
  [ngClass]="{
    primary: type === 'primary',
    secondary: type === 'secondary',
    destructive: type === 'destructive',
    small: size === 'small',
    medium: size === 'medium',
    large: size === 'large',
    disabled: disabled,
    loading: loading,
    iconOnly: !label,
    'no-border': noBorder,
    ghost: isGhost,
  }"
  [ngStyle]="{ width: getWidth() }"
  [disabled]="disabled || loading"
  [attr.aria-busy]="loading || null"
  [attr.aria-label]="!label ? ariaLabel : null">
  @if (loading) {
    <flow-loader [color]="loaderColor" [customColor]="loaderCustomColor" [size]="!label && (size === 'small' || size === 'medium') ? 'small' : 'medium'" class="flow-button-loader" />
  }
  <span class="flow-button-content" [class.invisible]="loading">
    @if (icon && iconLeft) {
      <div class="flow-button-icon" aria-hidden="true" [ngStyle]="{ width: imageSize, height: imageSize }">
        <img [src]="icon" alt="" />
      </div>
    }
    @if (label) {
      <p agText="body-3-medium">{{ label }}</p>
    }
    @if (iconRight || (doubleIcon && icon)) {
      <div class="flow-button-icon" aria-hidden="true" [ngStyle]="{ width: imageSize, height: imageSize }">
        <img [src]="iconRight || icon" alt="" />
      </div>
    }
  </span>
</button>
